import React from 'react';
import Product from "components/partials/product";
import {Categories} from "api";
import _ProductsByCategory from './_ProductsByCategory.scss';
import {Link} from 'react-router-dom';

class ProductsByCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 5
    };
  }

  componentDidMount() {
    let params = {
      id: this.props.subCategoryID,
      filter: {
        where: {
          status: 1
        },
        limit: this.state.limit,
        order: 'updatedAt DESC'
      }
    };
    Categories.actions.listProducts.request(params).then(response => {
      if (response && response.data) {
        let products = this.state.data;
        response.data.map((item, idx) => {
          products.push(item);
        });
        this.setState({data: products});
      }
    });
  }

  render() {
    return (
      <div className='container-product-by-category'>
        <div className='list-products'>
        <div className='category'>
          <div className='image-category'>
            <img src={this.props.imageCategory}/>
          </div>
          <h3 className='category-title'>{this.props.categoryTitle}</h3>
          <Link to={`/category/${this.props.categoryID}`} className='viewmore-product'>XEM TẤT CẢ</Link>
        </div>
          {
            this.state.data.map((item, i) => {
              return (
                <div key={i}>
                  <Product
                    enableSendRequest={false}
                    enableAddProduct={false}
                    {...item}/>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default ProductsByCategory;



// WEBPACK FOOTER //
// ./components/home/sub-view/ProductsByCategory.jsx